<template>
     <el-container class="pagination-list custom-function">
      <el-main>
        <div class="content">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item>
              <div class="operation">
                <el-input  prefix-icon="el-icon-search" v-model="conditions.keyword" placeholder="请输入函数名称" @keyup.enter.native="search" clearable/>
                <el-button class="search-button" @click="search">查询</el-button>
              </div>
            </el-form-item>
            <el-form-item class="operation-buttons">
                <el-button @click="addRow" type="primary">新建函数</el-button>
            </el-form-item>
          </el-form >
            <div class="table-list">
              <el-table height="calc(100% - 60px)" :data="items" v-loading="loading" width="100%" @row-click="rowClick">
                <template  v-for="(col,index) in cols" >
                  <el-table-column :key="index"
                  :prop="col.prop" :label="col.label" align="center" show-overflow-tooltip>
                  </el-table-column>
                </template>
                  <el-table-column
                  fixed="right" label="操作" align="center">
                    <template slot-scope="scope">
                      <el-button type="text" @click="editRow(scope.row)">编辑</el-button>
                      <el-button class="del-row" type="text" @click="delRow(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                  <template slot="empty">
                    <div >
                    <img src="@/globalComponent/calculation/assets/nothing.png" alt="无内容">
                    <p>点击右上角按钮新建函数</p>
                   </div>
                  </template>
                </el-table>
                <el-footer height="32px" class="pagination-footer">
                  <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pagination.currentPage"
                    :page-sizes="pagination.pageSizes"
                    :page-size="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total">
                  </el-pagination>
                </el-footer>
           </div>
        </div>
        <el-tabs v-model="activeTab" type="card" v-if="quoteShow">
          <el-tab-pane label="引用记录">
              <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
          <div class="operation">
                <el-input  prefix-icon="el-icon-search" v-model="referenceName" placeholder="请输入名称" @keyup.enter.native="searchReference" clearable/>
                <el-button class="search-button" @click="searchReference">查询</el-button>
              </div>
            </el-form-item>
          </el-form>
          <el-table v-if="items.length"  class="table-list-quote" :data="quoteItems" v-loading="loading" height='250' width="100%" empty-text="无引用数据">
            <template  v-for="(col,index) in quoteCols" >
              <el-table-column :key="index"
              :prop="col.prop" :label="col.label" align="center" show-overflow-tooltip>
              </el-table-column>
            </template>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-main>
    <el-dialog
      class="custom-function-dialog"
      :title="functionDialog.title"
      v-if="functionDialog.visiable"
      :visible.sync="functionDialog.visiable"
      width="932px"
      center
      :before-close="closeDialog"
      :close-on-click-modal="false">
       <div>
        <div class="popover-intro" :style="{top:func.top+'px',display:func.display}" @mouseenter="func.display='block'">
            <div class="function">{{func.value}}</div>
            <div class="title">函数简介</div>
            <div class="tip">{{func.tip}}</div>
            <div class="tip"> 示例：{{func.example}}</div>
          </div>
          <ul v-show="conform.hasCorrectFormula" class="code-mirror" :style="{left:conform.left+'px',top:conform.top+'px'}">
            <li v-for="(item,index) in conform.formulas" :key="index" :class="{'active':conform.active===index}" @click="clickformula(index)">{{item}}</li>
          </ul>
          <el-form ref="form" class="function-design" label-position="left" :inline="true" :model="functionForm" >
            <el-form-item label-width="90px" label="函数名称" prop="name" :rules=" {required: true, message: '请输入函数名称', trigger: 'blur'}">
              <el-input class="name" :value="functionForm.name" @input="watchName" placeholder="请输入" clearable/>
            </el-form-item>
            <div class="content">
              <div class="title">定义参数</div>
              <div class="param-list">
                <div class="flex" v-for="(el,i) in functionForm.paramList" :key="i">
                  <el-form-item :prop="'paramList.'+i+'.paramName'" :rules="{required: true, message: '请输入参数名', trigger: 'blur'}">
                  <el-input v-model="el.paramName" placeholder="请输入参数名" clearable/>
                  </el-form-item>
                  <el-form-item :prop="'paramList.'+i+'.paramValue'" :rules="{required: true, message: '请输入测试参数值', trigger: 'blur'}">
                    <el-input  v-model="el.paramValue" placeholder="请输入测试参数值" clearable/>
                  </el-form-item>
                  <i class="el-icon-delete del-Field" @click="delField(i)"></i>
                </div>
                <span class="add-field" @click="addField()">+ 添加定义参数</span>
              </div>
        </div>
        <div class="select-type">
          <span>逻辑函数</span>
          <el-select :value="functionForm.type" placeholder="请选择" @change="changeType">
            <el-option label="表达式" value="expression"></el-option>
            <el-option label="JavaScript" value="js"></el-option>
          </el-select>
        </div>
        <div class="calclation" :style="{'border-color':this.testFunc.error||testFunc.required?'#F53F3F':'#DBDBDB'}">
           <div class="left" @mouseleave="func.display='none'" v-show="functionForm.type==='expression'">
            <div class="modal-calc">
              <div class="tab-formula">
                <el-input class="search-formula" placeholder="搜索函数" v-model="letfSearch.keyword">
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <div @mouseleave="func.display='none'" v-show="!letfSearch.visiable">
                  <el-collapse class="func-collapse" v-model="activeNames">
                    <el-collapse-item v-for="(list,index) in options" :key="index" :title="list.label" :name="list.label">
                      <div class="item"  v-for='item in list.children' :key='item.id' @mouseenter="mouseEnter($event,item)" @mouseleave="func.display='none'" @click="insertFormula(item)">
                        <div class="tip"><span class="func">{{item.label}}</span>{{item.tip}}</div>
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </div>
                <div class="search-collapse" v-show="letfSearch.visiable" >
                  <div v-if="letfSearch.list.length>0">
                  <div class="item" v-for='item in letfSearch.list' :key='item.id' @mouseenter="mouseEnter($event,item)" @mouseleave="func.display='none'" @click="insertFormula(item)">
                     <div class="tip"><span class="func">{{item.label}}</span>{{item.tip}}</div>
                  </div>
                  </div>
                  <div class="no-list" v-else>
                    <img src="@/globalComponent/calculation/assets/nothing.png" alt="无内容">
                    <p>暂无搜索内容</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right" @mouseenter="func.display='none'"  :style="{'width':functionForm.type==='expression'?'calc(100% - 215px)':'100%'}">
            <div class="formula"
                      contenteditable
                      @blur="saveCursor"
                      @input="watchFormula($event)"
                      ref='formula'
                      v-html="htmlContent">
            </div>
          </div>
        </div>
        <div class="error" v-if="testFunc.error">{{functionForm.type==='expression'?'表达式':'JavaScript'}}错误</div>
        <div class="error" v-if="testFunc.required">请输入表达式</div>
        <div class="test-func">
          <span class="button-test" @click='testFunction'>测试此函数</span>
          <span>输出结果：{{testFunc.value}}</span>
        </div>
        <p class="func-tip">函数说明</p>
        <el-form-item label="" prop="tip" :rules=" {required: true, message: '请输入函数说明', trigger: 'blur'}">
          <el-input class="tip" v-model="functionForm.tip" type="textarea"
                            rows="5" clearable/>
        </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="savefunctionForm">保 存</el-button>
        <el-button @click="functionDialog.visiable = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog class="function-has-attr-change-dialog" :visible.sync="hasAttrChange" center :top="'0'" :close-on-click-modal="false" :close-on-press-escape="false">
        <span>是否保存此函数的更改</span>
        <div slot="footer" class="dialog-footer">
          <el-button @click="buttonClick(1)">不保存</el-button>
          <el-button @click="buttonClick(2)">取消</el-button>
          <el-button type="primary" @click="buttonClick(3)">保存</el-button>
        </div>
    </el-dialog>
    <transition name="el-fade-in-linear">
      <div class="modal-body" v-show="changeTypeMessage.showHint">
        <div class="modal-content">
          <div class="title">您确定要切换吗?<br> 切换后输入框内容将会清空</div>
          <div class="operation">
            <el-button type="primary" @click="hintClick">确定</el-button>
            <el-button @click="hintCancel">取消</el-button>
          </div>
        </div>
      </div>
    </transition>
  </el-container>
</template>

<script>
import {getFormula} from '@/globalComponent/calculation/formula.js'
import { UUID } from '@/plugins/common'
export default {
  name: 'CustomFunction',
  data () {
    return {
      activeTab: '0',
      // 输入公式时符合的公式
      conform: {
        hasCorrectFormula: true,
        formulas: [],
        active: 0
      },
      functionDialog: {
        visiable: false,
        id: '',
        title: '新建函数'
      },
      lastFunctionForm: {
        id: '',
        name: '',
        paramList: [{paramName: '', paramValue: ''}],
        type: 'expression',
        tip: '',
        expression: ''
      },
      functionForm: {
        id: '',
        name: '',
        paramList: [{paramName: '', paramValue: ''}],
        type: 'expression',
        tip: '',
        expression: ''
      },
      conditions: { keyword: '' },
      pagination: {currentPage: 1, pageSize: 10, pageSizes: [10, 20, 30, 50, 100], total: 0},
      loading: false,
      items: [],
      cols: [
        {prop: 'name', label: '函数名称'},
        {prop: 'tip', label: '说明'},
        {prop: 'createdTime', label: '创建时间'},
        {prop: 'createdUserName', label: '创建人'},
        {prop: 'lastModifiedTime', label: '修改时间'},
        {prop: 'lastModifiedUserName', label: '修改人'}
      ],
      quoteCols: [
        {prop: 'referenceName', label: '名称'},
        {prop: 'type', label: '类型'},
        {prop: 'createdUserName', label: '创建人'},
        {prop: 'createdTime', label: '创建时间'}
      ],
      filters: {},
      htmlExpression: '',
      parameter: {
        functionType: ['simple', 'math', 'text', 'date', 'logic', 'concat', 'system']
      },
      // 左侧面板的公式字段
      letfSearch: {
        keyword: '',
        list: [],
        visiable: false
      },
      leftPage: {
        value: [],
        tip: '',
        example: '',
        cacheformula: '',
        cacheRange: ''
      },
      activeNames: [],
      options: this.$_.cloneDeep(getFormula()),
      // 悬浮的公式的介绍
      func: {
        value: '',
        tip: '',
        left: 0,
        top: 0,
        display: 'none'
      },
      regsOptions: [],
      testFunc: {
        value: '',
        error: false,
        required: false
      },
      quoteItems: [],
      quoteShow: false,
      hasAttrChange: false,
      referenceName: '',
      changeTypeMessage: {
        tempType: '',
        showHint: false
      }
    }
  },
  created () {
    this.getTableData()
  },
  mounted () {
    document.onclick = () => {
      this.conform.hasCorrectFormula = false
    }
    this.$_.cloneDeep(this.options).forEach(m => {
      m.children && m.children.forEach(n => {
        if (n.label && !this.regsOptions.includes(n.label)) {
          this.regsOptions.push(n.label)
        }
      })
    })
    document.onkeydown = (event) => {
      let e = event || window.event
      // 键盘按下事件
      // 38up键 40 down 键
      if (e && e.keyCode === 40) {
        this.conform.active++
        if (this.conform.active >= this.conform.formulas.length) {
          this.conform.active = 0
        }
      }
      if (e && e.keyCode === 38) {
        this.conform.active--
        if (this.conform.active < 0) {
          this.conform.active = this.conform.formulas.length - 1
        }
      }
      if (e.keyCode === 13) {
        if (this.conform.hasCorrectFormula && this.conform.formulas.length) {
          // 点击回车输入到公式栏里
          this.enterInsert()
          this.conform.hasCorrectFormula = false
          return false
        }
      }
    }
  },
  computed: {
    htmlContent () {
      let expression = this.functionForm.expression
      if (expression) {
        this.expressionToWithCode(expression)
        return this.htmlExpression
      }
    }
  },
  watch: {
    'letfSearch.keyword' (val) {
      if (val) {
        this.letfSearch.visiable = true
        this.letfSearch.list = []
        this.options.forEach(m => {
          m.children.forEach(n => {
            if (n.label.toUpperCase().includes(val.toUpperCase())) {
              if (!this.letfSearch.list.find(el => el.label === n.label)) {
                this.letfSearch.list.push({value: n.value, label: n.label, tip: n.tip, example: n.example})
              }
            }
          })
        })
      } else {
        this.letfSearch.visiable = false
      }
    }
  },
  methods: {
    watchName (val) {
      // 函数名称必须大写
      this.functionForm.name = val.replace(/[^a-zA-Z]/g, '').toUpperCase()
    },
    addRow () {
      this.functionDialog.visiable = true
      this.letfSearch.keyword = ''
      this.testFunc.value = ''
      this.functionForm = {
        id: UUID.create(),
        name: '',
        paramList: [{paramName: '', paramValue: ''}],
        type: 'expression',
        tip: ''
      }
      this.functionDialog.title = '新建函数'
    },
    editRow (row) {
      this.functionDialog.visiable = true
      this.letfSearch.keyword = ''
      this.testFunc.value = ''
      this.functionDialog.title = '编辑函数'
      this.$axios.get(`/system-api/function/${row.id}`).then((res) => {
        res.data.name = res.data.name.replace(/[^a-zA-Z]/g, '').toUpperCase()
        this.lastFunctionForm = this.$_.cloneDeep(res.data)
        this.testFunc.error = false
        this.functionForm = res.data
      })
    },

    delRow (row) {
      this.$confirm('', '你确认删除吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'deleMessageBox',
        center: true
      })
        .then(() => this.$axios.delete(`/system-api/function/${row.id}`))
        .then(res => {
          this.getTableData()
        })
    },
    search () {
      // 页数为 1
      this.pagination.currentPage = 1
      this.initParams()
    },
    initParams () {
      this.filters = {
        'keyword': this.conditions.keyword
      }
      this.getTableData()
    },
    searchReference () {
      this.getReference()
    },
    rowClick (row, column, event) {
      this.currentRow = row
      this.quoteShow = true
      this.getReference()
    },
    getReference () {
      this.$axios.get('/system-api/function/reference', {params: {name: this.currentRow.name, referenceName: this.referenceName}}).then((res) => {
        this.quoteItems = res.data
      })
    },
    // 调用接口获取tableData数据
    getTableData () {
      this.loading = true
      let page = this.pagination
      let params = {
        'index': page.currentPage,
        'size': page.pageSize
      }
      params.filters = this.filters

      this.$axios.get('/system-api/function/list', {params})
        .then((res) => {
          // 页面数据改变重新统计数据数量和当前页
          this.pagination.total = res.data.total
          if (this.pagination.total && (this.pagination.currentPage - 1) * this.pagination.pageSize >= this.pagination.total) {
            this.pagination.currentPage--
            return
          }
          this.items = res.data.items
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    // 公式div的失焦事件
    saveCursor () {
      let sel = window.getSelection()
      if (sel.rangeCount) {
        this.leftPage.cacheRange = sel.getRangeAt(0)
        this.leftPage.cacheRange.anchorNode = sel.anchorNode
        this.leftPage.cacheRange.anchorOffset = sel.anchorOffset
        this.leftPage.cacheRange.focusNode = sel.focusNode
        this.leftPage.cacheRange.focusOffset = sel.focusOffset
      }
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
      this.getTableData()
    },
    addField () {
      this.functionForm.paramList.push({paramName: '', paramValue: ''})
    },
    delField (index) {
      this.functionForm.paramList.splice(index, 1)
    },
    savefunctionForm () {
      this.$refs['form'].validate((valid) => {
        this.functionForm.expression = this.getValue()
        if (!this.functionForm.expression) {
          this.testFunc.required = true
          return false
        } else {
          this.testFunc.required = false
        }

        if (valid) {
          let params = {
            'name': this.functionForm.name
          }
          this.$axios.get(`/system-api/function/${this.functionForm.id}/validateName`, {params})
            .then(() => {
              delete this.functionForm.paramStr
              return this.$axios.post('/system-api/function', this.functionForm)
            }).then(() => {
              this.functionDialog.visiable = false
              this.getTableData()
            })
        }
      })
    },
    expressionToWithCode (expression) {
      expression.match(/\$\{(.+?)\}/g) && expression.match(/\$\{(.+?)\}/g).map((el) => {
        let dataid = el.replace(/[${}]/g, '').split(',')[0].split('+')[0]
        let relationId = el.replace(/[${}]/g, '').split(',')[0].split('+')[1]
        let codeAttr = this.find(this.getDataSource, dataid, relationId)
        let code = `&nbsp;<code contenteditable="false" dataid=${codeAttr.column.id}+${codeAttr.relationId} name=${codeAttr.column.name} type="${codeAttr.column.dataType}">${codeAttr.tableName}-${codeAttr.column.name}</code>&nbsp;`
        expression = expression.replace(el, code)
      })
      this.htmlExpression = this.handleFuncColor(expression)
    },
    // 处理公式的函数名颜色
    handleFuncColor (expression) {
      let str = this.regsOptions.join('|')
      // eslint-disable-next-line
      str = eval('/\\b' + str.replace(/\|/g,'\\b|\\b') + '\\b/g')
      // 先把全部span替换成没有span的，然后再讲函数名全部替换成有span
      expression.match(/<span(.+?)<\/span>/g) && expression.match(/<span(.+?)<\/span>/g).map((el) => {
        let func = el.slice(el.indexOf('>') + 1, el.indexOf('</span>'))
        expression = expression.replace(el, func)
      })
      let comfirmOption = this.unique(expression.match(str))
      comfirmOption.forEach(m => {
        // eslint-disable-next-line
        let everyOptions = eval('/\\b' + m + '\\b/g')
        expression = expression.replace(everyOptions, `<span contenteditable="false">${m}</span>`)
      })

      return expression
    },
    unique (arr) {
      return Array.from(new Set(arr))
    },
    insertFormula (item) {
      this.leftPage.cacheformula = item.value !== 'logicOperation' ? item.value : ''
      this.leftPage.tip = item.tip
      this.leftPage.example = item.example
      let sel = window.getSelection()
      sel.removeAllRanges()
      if (!this.leftPage.cacheRange) {
        this.$message.info('请点击右侧表达式处')
        return false
      }
      sel.addRange(this.leftPage.cacheRange)
      this.selectFormula(this.$refs.formula)
      if (this.leftPage.cacheformula === '(DISTINCT)') {
        let formula = 'DISTINCT'
        let html = this.leftPage.cacheformula.replace(formula, `<span contenteditable='false'>${formula}</span>`)
        document.execCommand('insertHTML', false, html)
      } else {
        let formula = this.leftPage.cacheformula.slice(0, this.leftPage.cacheformula.indexOf('('))
        let html = this.leftPage.cacheformula.replace(formula, `<span contenteditable='false'>${formula}</span>`)
        document.execCommand('insertHTML', false, html)
      }
    },
    selectFormula (selector) {
      selector.focus()
      let sel = window.getSelection()
      if (sel.anchorOffset === 0) {
        sel.selectAllChildren(selector)
        sel.collapseToEnd()
      }
    },
    // 光标选中第一个param
    selectParam (selector) {
      selector.focus()
      let sel = window.getSelection()
      let range = sel.getRangeAt(0)
      for (let i = 0, length = selector.childNodes.length; i < length; i++) {
        if (selector.childNodes[i].nodeName === '#text') {
          let str = selector.childNodes[i].data
          let arr = str.split('param')
          let num = arr.length - 1
          if (num >= 1) {
            // 选择第一个param为光标范围
            range.setStart(selector.childNodes[i], arr[0].length)
            range.setEnd(selector.childNodes[i], arr[0].length + 5)
            break
          }
        }
      }
    },
    // 输入公式的时候
    watchFormula (event) {
      this.testFunc.required = false
      if (this.functionForm.type === 'js') {
        return false
      }
      // 输入值的时候
      if (event.data) {
        // 让右侧的提示公式出现
        this.conform.active = 0
        this.conform.left = window.getSelection().getRangeAt(0).getBoundingClientRect().left + 10
        this.conform.top = window.getSelection().getRangeAt(0).getBoundingClientRect().top + 10
        this.conform.hasCorrectFormula = true
        let sel = window.getSelection()
        if (sel) {
          this.leftPage.cacheRange = sel.getRangeAt(0)
          let range = this.leftPage.cacheRange
          if (sel.anchorNode.data) {
            let strPosition = sel.anchorOffset
            let str = sel.anchorNode.data.slice(0, strPosition)
            let handleStr = str
            if (str) {
              // 截取最后一个非英文以后的值
              let lastPosition = str.split('').reverse().join('').search(/[^a-zA-Z]+/)
              if (lastPosition >= 0) {
                handleStr = str.slice(str.length - lastPosition)
              }
              if (handleStr) {
                this.replaceCorrentFunc(sel, str, range, handleStr, lastPosition)
              } else {
                // 输入最后一个是非数字的值，并且当前是个函数名的span标签内，得把当前的非英文文字变成普通的颜色。例如SUM(中的(是黑色
                if (lastPosition === 0) {
                  this.conform.formulas = []
                  let newStr = str.slice(str.length - 1)
                  if (sel.anchorNode.parentElement.nodeName === 'SPAN') {
                    let range2 = window.getSelection().getRangeAt(0)
                    range2.setStart(range.startContainer, range2.startOffset - newStr.length)
                    range2.setEnd(range.startContainer, range2.startOffset + newStr.length)
                    setTimeout(() => {
                      document.execCommand('insertHTML', false, newStr)
                      sel.collapseToEnd()
                    }, 100)
                  }
                }
              }
            }
          }
        }
      } else if (event.inputType === 'deleteContentBackward') {
        let sel = window.getSelection()
        if (sel.anchorNode.data) {
          this.leftPage.cacheRange = sel.getRangeAt(0)
          let range = this.leftPage.cacheRange
          let strPosition = sel.anchorOffset
          let str = sel.anchorNode.data.slice(0, strPosition)
          let handleStr = str
          if (str) {
            // 截取最后一个非英文以后的值
            let lastPosition = str.split('').reverse().join('').search(/[^a-zA-Z]+/)
            if (lastPosition >= 0) {
              handleStr = str.slice(str.length - lastPosition)
            }
            if (handleStr) {
              this.replaceCorrentFunc(sel, str, range, handleStr, lastPosition)
            } else {
              this.conform.hasCorrectFormula = false
            }
          }
        } else {
          this.conform.hasCorrectFormula = false
        }
      }
    },
    replaceCorrentFunc (sel, str, range, handleStr, lastPosition) {
      // 输入符合的公式的时候出变色
      let findFunc = this.regsOptions.find(n => n === handleStr)
      if (findFunc) {
        this.conform.hasCorrectFormula = false
        if (lastPosition >= 0) {
          handleStr = str.slice(str.length - lastPosition)
          range.setStart(range.startContainer, str.length - lastPosition)
          range.setEnd(range.startContainer, str.length - lastPosition + handleStr.length)
        } else {
          range.setStart(range.startContainer, 0)
          range.setEnd(range.startContainer, str.length)
        }
        setTimeout(() => {
          document.execCommand('insertHTML', false, '')
          var range1 = window.getSelection().getRangeAt(0)
          var nnode = document.createElement('span')
          range1.surroundContents(nnode)
          nnode.innerHTML = `${handleStr}`
          sel.collapseToEnd()
          this.leftPage.cacheRange = sel.getRangeAt(0)
        }, 100)
      } else {
        if (sel.anchorNode.parentElement.nodeName === 'SPAN') {
          let range = window.getSelection().getRangeAt(0)
          range.setStart(range.startContainer, 0)
          range.setEnd(range.startContainer, handleStr.length)
          document.execCommand('insertHTML', false, handleStr)
          sel.collapseToEnd()
          this.leftPage.cacheRange = sel.getRangeAt(0)
        }
      }
      // 有符合的提示公式会push到数组里
      this.conform.formulas = []
      this.regsOptions.forEach(el => {
        if (el.slice(0, handleStr.length) === handleStr.toUpperCase()) {
          this.conform.formulas.push(el)
        }
      })
    },
    mouseEnter ($event, item) {
      if ($event.toElement.className === 'item') {
        if (this.func.value !== item.value) {
          this.func.top = $event.pageY
          this.func.value = item.value
          this.func.tip = item.tip
          this.func.example = item.example
        }
        this.func.display = 'block'
      } else {
        this.func.display = 'none'
      }
    },
    clickformula (index) {
      this.conform.active = index
      this.conform.hasCorrectFormula = false
      this.enterInsert()
      return false
    },
    enterInsert () {
      let range = this.leftPage.cacheRange
      let strPosition = this.leftPage.cacheRange.startOffset
      let str = this.leftPage.cacheRange.startContainer.data && this.leftPage.cacheRange.startContainer.data.slice(0, strPosition)
      let handleStr = str
      if (str) {
        // 截取最后一个非英文以后的值
        let lastPosition = str.split('').reverse().join('').search(/[^a-zA-Z]+/)
        if (lastPosition >= 0) {
          handleStr = str.slice(str.length - lastPosition)
          range.setStart(range.startContainer, str.length - lastPosition)
          range.setEnd(range.startContainer, str.length - lastPosition + handleStr.length)
        } else {
          range.setStart(range.startContainer, 0)
          range.setEnd(range.startContainer, str.length)
        }
        setTimeout(() => {
          let gongshi = null
          let arr = this.$_.cloneDeep(this.options)
          for (let i = 0; i < arr.length; i++) {
            gongshi = arr[i].children.find(n => n.label === this.conform.formulas[this.conform.active])
            if (gongshi) {
              break
            }
          }
          if (gongshi) {
            this.leftPage.cacheformula = gongshi.value
            this.leftPage.tip = gongshi.tip
            this.leftPage.example = gongshi.example
            let html = ''
            if (this.leftPage.cacheformula === '(DISTINCT)') {
              let formula = 'DISTINCT'
              html = this.leftPage.cacheformula.replace(formula, `<span contenteditable="false">${formula}</span>`)
            } else {
              let formula = this.leftPage.cacheformula.slice(0, this.leftPage.cacheformula.indexOf('('))
              html = this.leftPage.cacheformula.replace(formula, `<span contenteditable="false">${formula}</span>`)
            }
            let sel = window.getSelection()
            sel.removeAllRanges()
            sel.addRange(this.leftPage.cacheRange)
            document.execCommand('insertHTML', false, html)
          }
        }, 100)
      }
    },
    getValue () {
      let formula = this.$refs.formula.innerHTML
      formula = formula.replace(/<div>/g, '')
      formula = formula.replace(/<\/div>/g, '')
      formula = formula.replace(/<br>/g, '')
      formula = formula.replace(/&amp;/g, '&')
      let handleFormula = this.getExpression(formula)

      return handleFormula
    },
    getExpression (formula) {
      if (formula === '') {
        return formula
      }
      // 处理函数名颜色问题
      formula.match(/<span(.+?)<\/span>/g) && formula.match(/<span(.+?)<\/span>/g).map((el) => {
        let func = el.slice(el.indexOf('>') + 1, el.indexOf('</span>'))
        formula = formula.replace(el, func)
      })

      formula = formula.replace(/&gt;/g, '>')
      formula = formula.replace(/&lt;/g, '<')
      formula.match(/<code(.+?)<\/code>/g) && formula.match(/<code(.+?)<\/code>/g).map((el) => {
        let dataid = el.match(/dataid="(.+?)"/g).toString()
        let type = el.match(/type="(.+?)"/g).toString()
        let name = el.match(/name="(.+?)"/g).toString()
        let newstr = ''
        if (type.includes('sql')) {
          newstr = `sql($\{${dataid.slice(8, dataid.length - 1)},${name.slice(6, name.length - 1)},${type.slice(6, type.length - 1)}})`
        } else {
          newstr = `$\{${dataid.slice(8, dataid.length - 1)},${name.slice(6, name.length - 1)},${type.slice(6, type.length - 1)}}`
        }
        el.replace(el, newstr)
        formula = formula.replace(el, newstr)
      })
      let handleFormula = formula.replace(/&nbsp;/g, '')
      return handleFormula
    },
    testFunction () {
      if (this.functionForm.type === 'js') {
        try {
          this.testFunc.error = false
          // eslint-disable-next-line
        this.testFunc.value = eval(this.getValue())
        } catch (error) {
          this.testFunc.error = true
          this.testFunc.value = ''
          console.log(error)
        }
      } else {
        let expression = this.getValue()
        let dataMap = {}
        this.functionForm.paramList.forEach(m => {
          if (expression.includes(m.paramName)) {
            let str = `@${m.paramName}@`
            dataMap[str] = isNaN(m.paramValue) ? m.paramValue : Number(m.paramValue)
          }
        })
        this.$axios.post('/system-api/function/calc', {'formula': expression, 'variables': dataMap}, {
          transformResponse: [function (data) {
            // 处理数字长度过长导致精度丢失问题
            return typeof data === 'number' ? data.request.response : data
          }]})
          .then(res => {
            this.testFunc.error = false
            this.testFunc.value = res.data
          })
          .catch(() => {
            this.testFunc.error = true
            this.testFunc.value = ''
          })
      }
    },
    changeType (val) {
      this.changeTypeMessage.tempType = val
      if (!this.$refs.formula.innerHTML) {
        this.functionForm.type = val
        return false
      }
      this.changeTypeMessage.showHint = true
    },
    hintClick () {
      this.functionForm.type = this.changeTypeMessage.tempType
      this.$refs.formula.innerHTML = ''
      this.testFunc.value = ''
      this.testFunc.error = false
      this.changeTypeMessage.showHint = false
    },
    hintCancel () {
      this.functionForm.type = this.changeTypeMessage.tempType === 'expression' ? 'js' : 'expression'
      this.changeTypeMessage.showHint = false
    },
    closeDialog (done) {
      this.functionForm.expression = this.getValue()
      if (this.functionDialog.title !== '添加自定义函数' && JSON.stringify(this.lastFunctionForm) !== JSON.stringify(this.functionForm)) {
        this.hasAttrChange = true
      } else {
        done()
      }
    },
    buttonClick (type) {
      if (type === 1) {
        this.functionDialog.visiable = false
      } else if (type === 3) {
        this.functionDialog.visiable = false
        this.savefunctionForm()
      }
      if (this.hasAttrChange) {
        this.hasAttrChange = false
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/common.scss';
.pagination-list.custom-function {
  position: relative;
  .el-main {
   .operation .el-input {
      width: 284px;
    }
    .search-button {
      width: 40px;
      height: 24px;
      border: 1px solid #55ACF1;
      color: #55ACF1;
      padding: 0;
      border-radius: 4px;
      margin-left: 18px;
    }

    .operation-buttons {
      .el-button {
        padding: 5px 10px;
      }
    }

    .content {
      height: auto;
      min-height: auto;
      .table-list {
       height: 384px;
      .del-row {
        color: #A5A5A5;

        &:hover {
          color: #FB9391;
        }

        &:active {
          color: #FB9391;
        }
      }

      .no-list {
        margin: 77px auto 0;
        text-align: center;
        color: #999999;
        font-size: 12px;
        height: 90%;
      }
    }
    }
  }
        & > .modal-body {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 9999;
      background-color: transparent;
      top: 0;
      left: 0;

      & > .modal-content {
        position: absolute;
        width: 340px;
        height: 122px;
        background-color: #fff;
        border: none;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        border-radius: 6px;
        left: calc(50% - 240px);
        top: calc(50% - 140px);
        box-shadow:0px 2px 7px 2px rgba(0, 0, 0, 0.15);
        opacity:0.95;

        .title {
          color: #232323;
          text-align: center;
          padding: 23px 0 13px 0;
          font-size: 12px;
          line-height: 2;
        }

        .operation {
          text-align: center;

          .el-button {
            width:82px;
            height:26px;
            padding: 0;
          }

          .no {
            background-color: #3a8ee6;
            border-color: #3a8ee6;
            margin-left: 50px;

            &:hover {
              background-color: #3a8ee6;
              border-color: #3a8ee6;
            }

            span {
              color: #fff;
            }
          }

          .yes {
            background-color: transparent;
            border-color: #54abf2;

            span {
              color: #54abf2;
            }

            &:hover {
              color: #54abf2;
              border-color: #54abf2;
              background-color: transparent;
            }

            &:active {
              border-color: #54abf2;
              background-color: transparent;
            }
          }
        }
      }
    }
}

.custom-function-dialog {
  .el-dialog {
    font-size: 12px;
    color: #2C2C2C;
    height: 745px;
    margin-top: 7vh !important;

    .el-dialog__header {
      padding: 6px 20px;
    }

    .el-dialog__body {
      overflow: auto;
      height: 661px;
      padding: 16px 19px 0;

      .el-input__inner {
        height: 26px;
        line-height: 26px;
      }
    }

    .popover-intro {
      position: absolute;
      z-index: 9999;
      width: 258px;
      background: #fff;
      border-radius: 4px;
      color: #484646;
      padding: 10px;
      box-shadow: 0px 0px 9px 0px rgba(198, 201, 203, 0.28);
      left: 205px;

      .function {
        border-bottom: 1px solid #EAEAEA;
        color: #484646;
        margin-bottom: 10px;
        padding-bottom: 10px;
        font-size: 12px;
      }

      .title {
        color: #C6C9CB;
        margin-bottom: 8px;
        font-size: 12px;
      }

      .tip {
        font-size: 12px;
      }
    }

    .code-mirror {
      position: fixed;
      max-height: 400px;
      overflow: auto;
      background: #FFFFFF;
      box-shadow: 0px 0px 9px 0px rgba(198, 201, 203, 0.28);
      border-radius: 4px;
      z-index: 991;

      li {
        min-width: 100px;
        padding: 5px;
        color: #484646;
        font-size: 12px;
        background: #fff;
        cursor: pointer;

        &.active {
          background: #E5EEF4;
        }

        &:hover {
          background: #ECF5FB;
        }

        &:active,
        &:link {
          background: #E5EEF4
        }
      }
    }

    .function-design {

      .flex {

        .dataSource-columns {
          width: 234px;

          .el-select {
            width: 100%;
          }
        }

        .table-columns {
          width: 234px;

          .el-select {
            width: 100%;
          }
        }

        &:hover {
          .del-Field {
            visibility: visible;
          }
        }

        .del-Field {
          color: #BDCCD9;
          visibility: hidden;
          cursor: pointer;
          margin-left: 2px;
          margin-top: 7px;

          &:hover {
            color: #FB9391;
          }

          &:active {
            color: #F33648;
          }
        }
      }

      .el-form-item {
        margin-bottom: 14px;

        .el-form-item__label {
          font-size: 12px;
          color: #2C2C2C;

          &::before {
            display: none;
          }
        }

        &.mr22 {
          margin-right: 22px;
        }
      }

      .name {
        width: 616px;
      }

      .tip {
        width: 892px;
      }

      .w89 {
        width: 89px;
      }

      .w227 {
        width: 227px;
      }

      .w178 {
        width: 178px;
      }

      .w85 {
        width: 85px;
      }

      .w188 {
        width: 188px;
      }

      .line {
        width: 100%;
        height: 1px;
        background: #DBDBDB;
      }

      .content {
        padding-top: 16px;
        position: relative;
        min-height: 58px;

        .title {
          font-size: 12px;
          color: #2C2C2C;
          margin-bottom: 12px;
          position: absolute;
          left: 0;
          top: 20px;
        }

        .add-field {
          color: #54ABF1;
          text-align: center;
          display: block;
          font-size: 12px;
          background: #fff;
          position: absolute;
          right: 10px;
          top: 16px;
          width: 100px;
          height: 26px;
          border: 1px solid #54ABF1;
          border-radius: 4px;
          line-height: 26px;
          cursor: pointer;

          &:hover {
            background: #CDE3FA;
          }

          &:active {
            background: #8cbfe8
          }
        }

        .param-list {
          padding-left: 90px;

          .el-form-item:nth-child(2n+1) {
            margin-right: 22px;
          }

          .el-input {
            width: 296px;
            height: 26px;
            line-height: 26px;
          }
        }
      }
    }

    .select-type {
      height: 30px;
      line-height: 30px;
      margin-top: 16px;

      .el-select {
        float: right;
      }
    }

    .calclation {
      overflow: hidden;
      width: 892px;
      height: 334px;
      border: 1px solid rgba(219, 219, 219, 1);
      border-radius: 4px;
      margin-top: 10px;

      .left {
        width: 198px;
        height: 334px;
        float: left;
        margin-left: 9px;
        border-right: 1px solid #EAEAEA;
        padding-top: 8px;

        .tab-formula {
          .search-formula {
            width: 180px;
          }

          .search-collapse {
            padding: 25px 20px;
            padding-right: 0;
            height: 404px;
            overflow: auto;

            .no-list {
              margin: 0 auto;
              width: 72px;
              height: 60px;
              display: block;

              margin-top: 84px;

              p {
                font-size: 12px;
                color: #2A2929;
              }
            }

          }

          .item {
            height: 26px;
            cursor: pointer;
            position: relative;
            color: #484646;
            font-size: 12px;
            line-height: 26px;

            .func {
              color: #484646;
              font-size: 12px;
              margin-right: 11px;
            }

            .tip {
              font-size: 12px;
              color: #AAA9A9;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            &:hover {
              background: #F1F6F9;

            }

            &:active {
              background: #E5EEF4;
            }
          }

          .el-collapse.func-collapse {
            height: 404px;
            overflow: auto;
            border: none;

            .el-collapse-item {

              .el-collapse-item__header {
                padding-left: 20px;
                position: relative;
                color: #2A2929;
                font-size: 14px;
                height: 35px;
                line-height: 35px;

                .el-collapse-item__arrow {
                  position: absolute;
                  left: 2px;
                  top: 50%;
                  margin-top: -7px;
                }
              }

              .el-collapse-item__content {
                margin-left: 20px;
              }
            }

          }
        }
      }

      .right {
        float: left;
        position: relative;

        .title {
          color: #2A2929;

          span {
            font-size: 12px;
            color: #CAC9C9;
          }
        }

        .formula {
          padding: 12px;
          padding-top: 10px;
          height: 324px;
          overflow: auto;
          width: 100%;
          line-height: 1.8;
          outline: none;

          span {
            color: #AC39E7;
          }

          code {
            padding: 2px 4px;
            color: #54ABF1;
            border-radius: 2px;
          }
        }

        .formula.filter {
          height: unset;
        }
      }
    }

    .error {
      color: #F53F3F;
    }

    .test-func {
      .button-test {
        display: inline-block;
        cursor: pointer;
        width: 76px;
        height: 28px;
        background: rgba(235, 235, 235, 1);
        border: 1px solid rgba(219, 219, 219, 1);
        border-radius: 4px;
        margin-top: 16px;
        line-height: 28px;
        font-size: 12px;
        text-align: center;
        margin-right: 16px;

        &:active {
          border-color: #54ABF1;
          background: #CDE3FA;
        }
      }
    }

    .func-tip {
      margin-top: 14px;
      margin-bottom: 14px;
    }
  }
}
.function-has-attr-change-dialog {
      .el-dialog.el-dialog--center {
        width: 400px;
        height: 172px;
        top: 30%;
        .el-dialog__header {
          background-color: #fff;
        }
        .el-dialog__body {
          text-align: center;
          height: calc(100% - 80px);
        }
        .el-dialog__footer {
          padding: 0;
          .dialog-footer {
            .el-button {
              width: 82px;
              height: 26px;
              border: 1px solid rgba(84,171,241,1);
              border-radius: 4px;
              padding: 0;
              color: #54ABF1;
            }
            .el-button--default {
              &:hover, &:active, &:focus {
                background-color: #fff;
                color: #54ABF1;
              }
            }
            .el-button--primary {
              color: #fff;
            }
          }
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/system/system/custom-function.vue